import { emitterProps, globalEmitter } from '@/components/helpers/emitter-event'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { on, addClass, selectAll, select } from 'helpers/dom'
import { map } from 'helpers/utils'
import { ignoreDisableBodyScroll } from '@/components/helpers/ignoreDisableBodyScroll'
import { detectBreakpoint } from '@/components/helpers/breakpoint'

const selectors = {
  CLOSE_SELECTOR: '.js-close-modal-dialog',
  CONTENT_SELECTOR: '.js-content-modal-dialog',
  OPEN_CLASS: 'modal-dialog-opened',
  OVERLAY_CLASS: 'modal-dialog-overlay',
  VALIDATE_FORM_CLASS: 'validate-form',
  BODY: 'body',
  MODAL_ACTIVE_CLASS: 'open-modal-default'
}

class ModalDialog extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  init() {
    this.closeBtn = this.querySelectorAll(selectors.CLOSE_SELECTOR)
    this.contentEl = this.querySelector(selectors.CONTENT_SELECTOR)
    this.isSlideOut = this.dataset && this.dataset.type === 'slideout'
    this.scrollTarget = this.getAttribute('data-scroll-target')
    this.attachEvents()
    this.addOverlay()
    this.isClearScrollLock = true
    this.isDesktop = detectBreakpoint('desktop')
    this.disableClickOverlay = this.getAttribute('disable-click-overlay')
  }

  attachEvents() {
    this.closeBtn.forEach((btn) => on('click', this.hide.bind(this), btn))
    on('click', this.hide.bind(this, false), this)
    this.contentEl && on('click', (e) => e.stopPropagation(), this.contentEl)
    on(
      'keyup',
      (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide()
      },
      this
    )
  }

  addOverlay() {
    if (this.isSlideOut && !select(`.${selectors.OVERLAY_CLASS}`, this)) {
      this.overlayEl = document.createElement('div')
      addClass(selectors.OVERLAY_CLASS, this.overlayEl)
      this.insertBefore(this.overlayEl, this.contentEl)
    }
  }

  show(target, init = false, customData) {
    init && this.init()
    /** Hide all opened modal before open new modal */

    const allModals = document.querySelectorAll(selectors.OPEN_CLASS)

    allModals.forEach((modal) => modal.hide())

    this.setAttribute('open', '')
    this.classList.add(selectors.OPEN_CLASS)

    select(selectors.BODY).classList.add(selectors.MODAL_ACTIVE_CLASS)
    globalEmitter.emit(emitterProps.modal.show, customData)

    // when open minicart -> open gift wrap modal -> close gift wrapp, ignore disable clearAllScrollLock
    if (customData?.giftWrappingData?.isCartPage && GM_STATE.shopify.templateName !== 'cart') {
      this.isClearScrollLock = false
    }

    if (!target) {
      const scrollTargetEl = selectAll(this.scrollTarget, this)

      map(ignoreDisableBodyScroll, [...scrollTargetEl, this.contentEl])
    } else {
      ignoreDisableBodyScroll(target)
    }
    !this.isDesktop && selectAll('body, #MainContent').forEach((el) => el.classList.add('overflow-hidden'))
  }

  hide(isBtn = true) {
    // Custom for when swipe item in Gift Wrapping Modal
    if (!isBtn && this.disableClickOverlay === 'true') return

    /** Refresh validate form when hide modal */
    const allFormsValidate = this.querySelectorAll(selectors.VALIDATE_FORM_CLASS)

    allFormsValidate.forEach((form) => form.refreshValidate())

    this.removeAttribute('open')
    this.classList.remove(selectors.OPEN_CLASS)
    select(selectors.BODY).classList.remove(selectors.MODAL_ACTIVE_CLASS)

    if (this.isClearScrollLock) {
      clearAllBodyScrollLocks()
      !this.isDesktop && selectAll('body, #MainContent').forEach((el) => el.classList.remove('overflow-hidden'))
    }
    this.dispatchEvent(new Event('close-modal'))
  }
}

customElements.define('modal-dialog', ModalDialog)
